export default {
  screens: [
    {
      type: 'intro',
      title: '尊榮冠冕',
      content:
        '尊榮冠冕是珠寶臻品和品牌的象徵，權力和時尚配飾的代表，展品從最具有古典韻味至奢華隆重的款式皆具備。',
      idYt: '2YX1UzJIlp0',
      videoCover: 'world/diademe/video.jpg',
      desktop: {
        cover: 'world/diademe/cover-1.jpg'
      },
      mobile: {
        cover: 'world/diademe/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: 'auto',
          height: '65%',
          bottom: '-18%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      content:
        '自1780年以來，品牌爲皇室貴族打造了2000餘款冠冕、髮飾和羽飾冠冕。  <br/><br/> 展場展出了20款冠冕和300餘款藝術傑作，Chaumet的豐富創意和精湛技藝可從中略見一斑。',
      isCover: true
    },
    {
      type: 'grid',
      videoBlock: {
        cover: 'world/diademe/video-diademe.jpg',
        idYt: 'IM2d5lCTqIA'
      },
      middleImg: 'world/diademe/gridMiddle.jpg',
      rightImg: 'world/diademe/gridRight.jpg',
      title: 'The Vertiges tiara',
      content:
        '“眩彩花園”冠冕（diadème Vertiges）設計二十一世紀的冠冕，這是Chaumet向倫敦藝術大學中央聖馬丁學院（Central Saint Martins）學生作出的挑戰。<br/><br/> 斯科特·阿姆斯特朗（Scott Armstrong）從法式花園中汲取靈感，設計了"眩彩花園"冠冕。純淨簡潔的曲線和線條重新銓釋了Chaumet的珠寶理念。'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/diademe.js